import "./LandingFeatures.css";

function LandingFeatures() {
  return (
    <section className="landing-features">
      <div className="landing-features__head">
        <span className="landing-features__eyebrow">Functionaliteiten</span>
        <h2 className="landing-features__title">Geavanceerde functies gebaseerd op de laatste technologie</h2>
        <p className="landing-features__subtitle">
          ContinuMee visualiseert survey data om de ervaringen met uw dienstverlening in beeld te brengen. ContinuMee werkt met een
          AI-aangedreven tekstanalysemodule waarmee het automatisch open antwoorden en andere ongestructureerde feedback kunt ordenen,
          duiden en er inzichten uit kunt halen samen met AImee, onze onderzoeks AI Agent
        </p>
      </div>

      <div className="landing-features__media">
        <img src="/ai-chat.png" alt="AI chat voorbeeld in ContinuMee" />
      </div>
    </section>
  );
}

export default LandingFeatures;
